<ng-template #featureCard let-feature="item">
  <div class="feature__container">
      <div class="feature__logo">
          <img [src]=feature.capability_icon_url>
      </div>
      <div class="feature__title">
          {{feature.name}}
      </div>
      <div class="feature__description">
          {{feature.description}}
      </div>
  </div>
</ng-template>

<h4>Features</h4>

<!-- template feature card -->
<brain-card-list [source]="featuresArray" [template]="featureCard">
</brain-card-list>
